import { useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AvailabilitiesItem from '../../components/AvailabilitiesItem';
import CustomAvailabilitiesTab from '../../components/CustomAvailabilitiesTab';
import UnavailabilitiesItem from '../../components/UnavailabilitiesItem';
import VehicleLayout from '../../components/VehicleLayout';
import { useAxios } from '../../utils/hook/useAxios';

function generateHourOptions() {
  const options = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 30) {
      const t = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
      options.push(
        <option key={t} value={t}>
          {t}
        </option>
      );
    }
  }
  return options;
}

function SettingAvailabilities() {
  const axios = useAxios();
  const { vehiculeId } = useParams();

  const userId = (() => {
    try {
      return JSON.parse(window.localStorage.getItem('VehicleStorage'))?.userId;
    } catch {
      return null;
    }
  })();

  const [showBlockPanel, setShowBlockPanel] = useState(false);
  const [UnavailabilityDateStart, setUnavailabilityDateStart] = useState('');
  const [UnavailabilityDateEnd, setUnavailabilityDateEnd] = useState('');
  const [selectedValue, setSelectedValue] = useState('00:00');
  const [selectedValue2, setSelectedValue2] = useState('00:00');
  const [HoteAvailabilitiesHome, setHoteAvailabilitiesHome] = useState([]);
  const [HoteAvailabilitiesDelivery, setHoteAvailabilitiesDelivery] = useState([]);
  const [IsAlwaysHomeAvailable, setIsAlwaysHomeAvailable] = useState(false);
  const [IsAlwaysDeliveryAvailable, setIsAlwaysDeliveryAvailable] = useState(false);
  const [Unvaivalabilities, setUnvaivalabilities] = useState([]);
  const [activeTab, setActiveTab] = useState('home');

  async function loadData() {
    const datavehicule = JSON.parse(window.localStorage.getItem('VehicleStorage'));
    const [res, resUnavail] = await Promise.all([
      axios.get('/hoteavailabilities/' + datavehicule.userId),
      axios.get('/hoteunavailabilities/' + datavehicule.userId),
    ]);

    if (resUnavail.data) setUnvaivalabilities(resUnavail.data);

    if (res.data) {
      const home = res.data.filter((i) => i.ModeAvailability === '0');
      const delivery = res.data.filter((i) => i.ModeAvailability === '1');
      setHoteAvailabilitiesHome(home);
      setHoteAvailabilitiesDelivery(delivery);
      if (home.length) setIsAlwaysHomeAvailable(home[0].alwaysAvailable);
      if (delivery.length) setIsAlwaysDeliveryAvailable(delivery[0].alwaysAvailable);
    }
  }

  useEffect(() => {
    loadData();
  }, []);

  async function toggleAlways(mode, current) {
    const datavehicule = JSON.parse(window.localStorage.getItem('VehicleStorage'));
    const value = !current;
    if (mode === '0') setIsAlwaysHomeAvailable(value);
    else setIsAlwaysDeliveryAvailable(value);
    await axios.put('/hoteavailabilities/updateHoteAvailabilitiesByUserId/' + datavehicule.userId, {
      alwaysAvailable: value,
      ModeAvailability: mode,
    });
    await loadData();
  }

  async function ajouterIndisponibilites() {
    const datavehicule = JSON.parse(window.localStorage.getItem('VehicleStorage'));
    await axios.post('/hoteunavailabilities', {
      userId: datavehicule.userId,
      startDate: new Date(UnavailabilityDateStart),
      endDate: new Date(UnavailabilityDateEnd),
      startTime: selectedValue,
      endTime: selectedValue2,
    });
    const res = await axios.get('/hoteunavailabilities/' + datavehicule.userId);
    if (res.data) setUnvaivalabilities(res.data);
    toast.success('Indisponibilité ajoutée');
    setUnavailabilityDateStart('');
    setUnavailabilityDateEnd('');
  }

  const TABS = [
    { key: 'home', label: 'Accueil' },
    { key: 'delivery', label: 'Livraison' },
    { key: 'personalized', label: 'Personnalisée' },
  ];

  return (
    <VehicleLayout vehicleId={vehiculeId} pageTitle="Disponibilités">
      <ToastContainer />

      {/* ── Offcanvas "Bloquer des disponibilités" ── */}
      <Offcanvas
        show={showBlockPanel}
        onHide={() => setShowBlockPanel(false)}
        placement="end"
        style={{ maxWidth: 460, width: '95vw' }}
      >
        <Offcanvas.Header closeButton className="border-bottom">
          <Offcanvas.Title className="fw-bold" style={{ fontSize: 16 }}>
            Bloquer des disponibilités
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="p-3">
          <p className="text-muted small mb-4">
            Bloquez vos disponibilités de prise en charge et de retour, de sorte que seuls les
            voyages débutant et se terminant en dehors de ces périodes puissent être réservés.
          </p>

          {/* Début */}
          <div className="row g-2 mb-3">
            <div className="col-7">
              <label className="form-label small fw-semibold mb-1">Début</label>
              <input
                type="date"
                className="form-control form-control-sm"
                value={UnavailabilityDateStart}
                onChange={(e) => setUnavailabilityDateStart(e.target.value)}
              />
            </div>
            <div className="col-5">
              <label className="form-label small fw-semibold mb-1">Heure</label>
              <select
                className="form-select form-select-sm"
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
              >
                {generateHourOptions()}
              </select>
            </div>
          </div>

          {/* Fin */}
          <div className="row g-2 mb-4">
            <div className="col-7">
              <label className="form-label small fw-semibold mb-1">Fin</label>
              <input
                type="date"
                className="form-control form-control-sm"
                value={UnavailabilityDateEnd}
                onChange={(e) => setUnavailabilityDateEnd(e.target.value)}
              />
            </div>
            <div className="col-5">
              <label className="form-label small fw-semibold mb-1">Heure</label>
              <select
                className="form-select form-select-sm"
                value={selectedValue2}
                onChange={(e) => setSelectedValue2(e.target.value)}
              >
                {generateHourOptions()}
              </select>
            </div>
          </div>

          <button
            className="btn btn-danger btn-sm w-100 mb-4"
            onClick={ajouterIndisponibilites}
            disabled={!UnavailabilityDateStart || !UnavailabilityDateEnd}
          >
            <i className="bi bi-slash-circle me-1"></i>Enregistrer
          </button>

          <div className="alert alert-info small mb-4">
            <i className="bi bi-arrow-left-right me-2"></i>
            Votre véhicule peut être utilisé pour un voyage durant votre période d'indisponibilité.
            Pour bloquer également la disponibilité du véhicule, accédez au calendrier.
          </div>

          <hr className="my-3" />

          {Unvaivalabilities.length > 0 ? (
            <>
              <p className="fw-semibold small mb-2">
                {Unvaivalabilities.length} indisponibilité
                {Unvaivalabilities.length > 1 ? 's' : ''} enregistrée
                {Unvaivalabilities.length > 1 ? 's' : ''}
              </p>
              {Unvaivalabilities.map((item) => (
                <UnavailabilitiesItem Data={item} key={item.id} />
              ))}
            </>
          ) : (
            <p className="text-muted small text-center py-2">
              <i className="bi bi-calendar-x me-1"></i>Aucune indisponibilité enregistrée
            </p>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* ── Contenu principal ── */}
      <h1 className="mb-3">Heures de prise en charge et de retour</h1>

      <div className="card border-0 shadow-sm rounded-3 p-3">
        {/* Bandeau "Bloquer" */}
        <div className="alert alert-success d-flex align-items-start gap-3 mb-3">
          <i className="bi bi-blockquote-left fs-4 flex-shrink-0"></i>
          <div className="flex-grow-1">
            <p className="fw-semibold mb-1">Bloquer des disponibilités</p>
            <p className="small mb-1">
              Indiquez les moments où vous n'êtes pas disponible pour rencontrer les invités.
            </p>
            <small className="text-muted">
              {Unvaivalabilities.length} date
              {Unvaivalabilities.length > 1 ? 's' : ''} d'indisponibilité
              {Unvaivalabilities.length > 1 ? 's' : ''} ajoutée
              {Unvaivalabilities.length > 1 ? 's' : ''}
            </small>
          </div>
          <button
            className="btn btn-sm btn-success flex-shrink-0"
            onClick={() => setShowBlockPanel(true)}
          >
            <i className="bi bi-plus me-1"></i>Bloquer
          </button>
        </div>

        {/* Onglets */}
        <ul className="nav nav-pills mb-3">
          {TABS.map(({ key, label }) => (
            <li className="nav-item flex-grow-1" key={key}>
              <button
                className={`nav-link w-100 ${activeTab === key ? 'active' : ''}`}
                onClick={() => setActiveTab(key)}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>

        {/* Tab : Accueil */}
        {activeTab === 'home' && (
          <div>
            <h3>Heures de prise en charge et de retour à votre domicile</h3>
            <p className="mb-3 text-muted small">
              Les invités peuvent réserver uniquement des voyages qui commencent et se terminent
              lorsque vous êtes disponible. Les heures définies s'appliquent à tous vos véhicules.
            </p>
            <div className="card mb-3">
              <div className="form-check form-switch d-flex justify-content-between align-items-center p-3">
                <label className="form-check-label fw-semibold">Toujours disponible</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  style={{ height: 28, width: 56 }}
                  checked={IsAlwaysHomeAvailable}
                  onChange={() => toggleAlways('0', IsAlwaysHomeAvailable)}
                />
              </div>
            </div>
            <hr />
            {HoteAvailabilitiesHome.length === 0 ? (
              <>
                <div className="alert alert-danger d-flex gap-2 align-items-start" role="alert">
                  <i className="bi bi-info-circle fs-5"></i>
                  <p className="mb-0 small">
                    Veuillez configurer vos disponibilités pour compléter votre annonce.
                  </p>
                </div>
                <button className="btn btn-sm btn-primary">
                  <i className="bi bi-plus-circle me-1"></i>Ajouter des disponibilités d'accueil par
                  défaut
                </button>
              </>
            ) : !IsAlwaysHomeAvailable ? (
              HoteAvailabilitiesHome.map((item) => (
                <AvailabilitiesItem WeekDay={item.Weekday} Data={item} key={item.id} />
              ))
            ) : (
              <p className="text-success small">
                <i className="bi bi-check-circle me-1"></i>Vous êtes toujours disponible pour
                l'accueil.
              </p>
            )}
          </div>
        )}

        {/* Tab : Livraison */}
        {activeTab === 'delivery' && (
          <div>
            <h3>Heures de prise en charge et de retour au lieu de livraison</h3>
            <p className="text-muted small mb-3">
              Ces heures s'appliquent aux véhicules livrés aux lieux que vous avez définis.
            </p>
            <div className="card mb-3">
              <div className="form-check form-switch d-flex justify-content-between align-items-center p-3">
                <label className="form-check-label fw-semibold">Toujours disponible</label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  style={{ height: 28, width: 56 }}
                  checked={IsAlwaysDeliveryAvailable}
                  onChange={() => toggleAlways('1', IsAlwaysDeliveryAvailable)}
                />
              </div>
            </div>
            <hr />
            {HoteAvailabilitiesDelivery.length === 0 ? (
              <>
                <div className="alert alert-danger d-flex gap-2 align-items-start" role="alert">
                  <i className="bi bi-info-circle fs-5"></i>
                  <p className="mb-0 small">
                    Veuillez configurer vos disponibilités pour compléter votre annonce.
                  </p>
                </div>
                <button className="btn btn-sm btn-primary">
                  <i className="bi bi-plus-circle me-1"></i>Ajouter des disponibilités de livraison
                  par défaut
                </button>
              </>
            ) : !IsAlwaysDeliveryAvailable ? (
              HoteAvailabilitiesDelivery.map((item) => (
                <AvailabilitiesItem WeekDay={item.Weekday} Data={item} key={item.id} />
              ))
            ) : (
              <p className="text-success small">
                <i className="bi bi-check-circle me-1"></i>Vous êtes toujours disponible pour la
                livraison.
              </p>
            )}
          </div>
        )}

        {/* Tab : Personnalisée */}
        {activeTab === 'personalized' && (
          <div>
            <h3 className="mb-1">Disponibilités personnalisées</h3>
            <p className="text-muted mb-4" style={{ fontSize: 13 }}>
              Définissez des créneaux horaires sur des dates spécifiques — par exemple pour un jour
              férié, un événement ou toute exception à votre planning habituel.
            </p>
            <CustomAvailabilitiesTab userId={userId} />
          </div>
        )}
      </div>
    </VehicleLayout>
  );
}

export default SettingAvailabilities;
